// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Popup } from './popup';

/**
 * @class Jsw.PopupSlider
 * @extends Jsw.Popup
 */
export const PopupSlider = Class.create(Popup, {
    _initConfiguration($super, config) {
        config = Object.extend({
            popupCls: 'popup-panel popup-panel-slider popup-panel-auto',
            closeButtonEnabled: true,
            hideOnEscape: true,
        }, config || {});
        $super(config);

        this._slides = this._getConfigParam('slides', []);
        this._current = this._getConfigParam('current', 0);
    },

    _getContentArea() {
        const name = `slider-${this.getId()}`;

        return '' +
            `<div class="slider infinity">${
                this._slides.map(function (item, index) {
                    return `<input type="radio" class="slider-check" name="${name}" id="${name}_${index + 1}" ${index === this._current ? 'checked="checked"' : ''}>`;
                }.bind(this)).join('')}` +
                `<ul class="slider-container">${
                    this._slides.map(function (item) {
                        return `<li class="slider-item">${item}</li>`;
                    }).join('')
                }</ul>` +
                `<div class="slider-arrows">${
                    this._slides.map(function (item, index) {
                        return `<label class="slider-label" for="${name}_${index + 1}"></label>`;
                    }).join('') +
                    (this._slides.length > 1 ? (
                        `<label class="slider-label goto-first" for="${name}_1"></label>` +
                        `<label class="slider-label goto-last" for="${name}_${this._slides.length}"></label>`
                    ) : '')
                }</div>` +
                '<div class="slider-navigation">' +
                    `<div class="slider-navigation-inner">${
                        this._slides.map(function (item, index) {
                            return `<label class="slider-label" for="${name}_${index + 1}"></label>`;
                        }).join('')
                    }</div>` +
                '</div>' +
            '</div>';
    },

    _onKeyDown($super, e) {
        $super(e);
        const slides = $$('.slider-check');
        const currentIndex = slides.indexOf($$('.slider-check:checked')[0]);
        switch (e.keyCode) {
            case Event.KEY_LEFT:
                slides[currentIndex === 0 ? slides.length - 1 : currentIndex - 1].checked = true;
                break;
            case Event.KEY_RIGHT:
                slides[currentIndex === slides.length - 1 ? 0 : currentIndex + 1].checked = true;
                break;
        }
    },
});



// WEBPACK FOOTER //
// ./jsw/popup-slider.js